export const ROUTE_CONST = {
  HOME: { path: '/', name: 'Home', view: 'Home' },
  HISTORY: { path: '/history', name: 'History', view: 'History' },
  PREVIEW: { path: '/preview', name: 'Preview', view: 'Preview' },
  SERVICE: { path: '/service', name: 'Service', view: 'Service' },
  RESULT: { path: '/result/:orderNo', name: 'Result', view: 'Result' }
}
